import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND } from '../../constants/branding';

interface BrandHeroWordmarkProps {
  showMark?: boolean;
  markHeight?: number;
}

/** Large hero display for the Aurieq brand name — matches logo typography. */
export const BrandHeroWordmark: React.FC<BrandHeroWordmarkProps> = ({
  showMark = true,
  markHeight = 72,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: { xs: 1.5, md: 2 },
    }}
  >
    {showMark && (
      <Box
        component="img"
        src={BRAND.assets.iconMark}
        alt=""
        aria-hidden
        sx={{
          height: markHeight,
          width: 'auto',
          objectFit: 'contain',
          filter: `drop-shadow(0 0 28px ${BRAND.colors.glow})`,
        }}
      />
    )}

    <Typography
      component="p"
      aria-label={BRAND.name}
      sx={{
        fontFamily: '"Inter", sans-serif',
        fontWeight: 800,
        fontSize: { xs: '3.25rem', sm: '4.5rem', md: '5.75rem' },
        lineHeight: 1,
        letterSpacing: { xs: '0.14em', md: '0.18em' },
        textTransform: 'uppercase',
        background: BRAND.gradient,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        filter: `drop-shadow(0 0 40px ${BRAND.colors.glow})`,
        userSelect: 'none',
      }}
    >
      {BRAND.nameUpper}
    </Typography>

    <Typography
      component="p"
      sx={{
        fontFamily: '"Inter", sans-serif',
        fontWeight: 300,
        fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.85rem' },
        letterSpacing: { xs: '0.35em', md: '0.45em' },
        textTransform: 'uppercase',
        color: BRAND.colors.primary,
        opacity: 0.9,
        mt: { xs: -0.5, md: -1 },
      }}
    >
      {BRAND.since}
    </Typography>
  </Box>
);

export default BrandHeroWordmark;
